import React, { useEffect } from 'react';

import { PageHeader, IframeView } from '../../components';
import { META_TITLE } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './AdminRequests.styles';

export default function AdminRequests() {
	useEffect(() => {
		// Set document title
		document.title = `Requests | ${META_TITLE}`;
	}, []);

	return (
		<S.Wrapper>
			<PageHeader>Requests</PageHeader>
			<IframeView src={buildIframeUrl('spRequests')} title="Requests" />
		</S.Wrapper>
	);
}
